<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('menu.pro_active')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item :to="{ path: '/muvofiqlashtiruvchi' }">{{$t('submenu.jamoatchilik_kengashi')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('muvofiq.muvofiq_title2')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
            <section class="section py-3">
                <div class="container">
                  <el-row :gutter="15">
                    <el-col :sm="24" :md="24" :lg="12" class="mb-3 mb-lg-10">
                      <div class="card card-lift shadow border-1 card_tuzilma">
                        <img src="img/yer_kengash.jpg" class="image_tuzilma">
                      </div>
                    </el-col>
                  </el-row>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1'
            };
        }
    }
</script>
<style>
</style>
